import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import AppErrorAlert from '../../shared/AppAlerts/AppErrorAlert';
import { Content } from '../../shared/Content';
import EDeliveryModalContainer from './EDeliveryModalContainer';
import { PsBeaconModal } from '../../shared/BeaconRegister';
import { closeModal } from '../../../Utils';

const EDeliveryModal = ({ dispatch }) => {

    const [serviceError, setServiceError] = React.useState(false);

    const handleClose = () => {
        closeModal('e-delivery');
    };

    const handleOpen = () => {
        dispatch({ type: 'LOAD_PROSPECTUS_DATA', loadProspectusData: true });
    }

    const closeError = () => setServiceError(false);

    const props = {
        handleClose,
        setServiceError,
    };

    return (
        <>
        {serviceError &&
            <AppErrorAlert
                dialogText={Content.planBlockedAlert.contentText}
                dialogTitle={Content.planBlockedAlert.contentTitle}
                close={closeError}
            />
            }
            <PsBeaconModal
                scale='jumbo'
                onBeaconEventOpen={handleOpen}
                handleClose={handleClose}
                id='e-delivery'
            >
                <Box className='beacon-theme-modern-outlook' id='e-delivery-modal-content-container' sx={{ paddingBottom: '16px' }}>
                    <Typography type='headline' serif scale={400} bold id='e-delivery-modal-ttle'>
                        Terms of Service
                    </Typography>
                    <Typography
                        id='e-delivery-modal-subtitle'
                        light
                        sx={{ paddingBottom: '16px' }}
                    >
                        To view your financial plan, complete each section of the Terms of Service below.
                    </Typography>
                    <EDeliveryModalContainer {...props} />
                </Box>
            </PsBeaconModal>
        </>
    );
};

export default EDeliveryModal;
